module.exports = __webpack_public_path__ + "static/img/lavado.4eb50e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lavado.jpg
// module id = 69TO
// module chunks = 1